export function checkMediaType(url: string): 'image' | 'video' | 'unknown' {
    try {
        const extension = new URL(url).pathname.split('.').pop()?.toLowerCase();

        if (!extension) {
            return 'unknown';
        }

        const imageExtensions = [
            'jpg',
            'jpeg',
            'png',
            'gif',
            'bmp',
            'webp',
            'svg',
        ];
        const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi'];

        if (imageExtensions.includes(extension)) {
            return 'image';
        } else if (videoExtensions.includes(extension)) {
            return 'video';
        } else {
            return 'unknown';
        }
    } catch {
        return 'unknown';
    }
}
